<div *ngIf="isIOSApp" class="ios-safe-area-overflow" [ngStyle]="{'top.px': 0, 'height.px': iosSafeAreaOverflowHeight}"></div>
<router-outlet appDownload appNotificationSound></router-outlet>

<app-loading-panel [showLoading]="loader" [hideText]="true" [isSmall]="true" ></app-loading-panel>